import React, { useEffect, useState } from "react";
import "./emailsent.css";
import { useMutation } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import CircleLoading from "../../../common/Loading/CircleLoading";
import { useOtpSTatus } from "../../../context/OtpContext";
import OtpLogo from "./OtpLogo";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const EmaillSentInput = () => {
  const [emailState, setEmailState] = useState({
    email: "",
    emailStatus: "unchecked",
  });
  const { otpStatus, setOtpStatus, otpEmail, setOtpEmail, setBrochedureId } =
    useOtpSTatus();
  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}send-otp`, values);
    },
    onError: (res) => {
      Swal.fire({
        title: "Email Invalid",
        icon: "error",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      });
    },
  });
  const location = useLocation();

  const id = location.state.id;

  useEffect(() => {
    setBrochedureId(null);
  }, []);

  useEffect(() => {
    if (mutation.isSuccess) {
      // localStorage.setItem("otpstatus", JSON.stringify(mutation.isSuccess));
      // localStorage.setItem("verifyemail", JSON.stringify(emailState.email));
      setOtpEmail(emailState.email);
      setOtpStatus(mutation.isSuccess);
      setBrochedureId(id);
    } else {
      // localStorage.setItem("otpstatus", JSON.stringify(mutation.isSuccess));
      // localStorage.setItem("verifyemail", JSON.stringify(emailState.email));
      setOtpEmail(emailState.email);
      setOtpStatus(mutation.isSuccess);
      setBrochedureId(null);
    }
  }, [mutation.data]);

  const handleChange = (e) => {
    let newdata = { ...emailState };

    if (e.target.name == "email") {
      const allCharactersLengthRegex = new RegExp("^.{4,50}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setEmailState(newdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      email: emailState.email,
    };
    mutation.mutate(values);
  };
  return (
    <div className="w-full h-screen  flex items-center justify-center flex-col ">
      <div class="emailform-container ">
        <OtpLogo />
        <div class="logo-container">Get access to Download Brochure</div>
        <form class="form" onSubmit={(e) => handleSubmit(e)}>
          <div class="form-group">
            <label className="font-semibold text-lg" for="email">Email</label>
            <input
              name="email"
              value={emailState.email}
              type="text"
              id="email"
              placeholder="Enter your email"
              onChange={(e) => handleChange(e)}
              className={`block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  sm:text-sm sm:leading-6 outline-none px-4 ${
                emailState.emailStatus == "success"
                  ? "input-success"
                  : emailState.emailStatus == "error"
                  ? "input-error"
                  : ""
              }`}
            />
            {emailState.emailStatus == "error" && (
              <p className="text-sm font-semibold">Email Invalid</p>
            )}
          </div>

          <button class="form-submit-btn" type="submit">
            {mutation.isLoading ? <CircleLoading /> : "Request OTP"}
          </button>
        </form>
        <div className="text-center">
          <p>
            By continuing, you agree to our <br />{" "}
            <span className="text-forging-yellow font-semibold hover:text-speed-red cursor-pointer">
              Terms of service{" "}
            </span>{" "}
            &{" "}
            <span className="text-forging-yellow font-semibold hover:text-speed-red cursor-pointer">
              Privacy policy
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmaillSentInput;
